import { render, staticRenderFns } from "./NewTransactionServicioForm.vue?vue&type=template&id=35c290f6&scoped=true"
import script from "./NewTransactionServicioForm.vue?vue&type=script&lang=js"
export * from "./NewTransactionServicioForm.vue?vue&type=script&lang=js"
import style0 from "./NewTransactionServicioForm.vue?vue&type=style&index=0&id=35c290f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c290f6",
  null
  
)

export default component.exports